import React from 'react';

import { mockDataUtil } from 'modules';



export interface IReturnAuthorization {
  firstName: string;
  lastName: string;
  email: string;
  emailPermission: string;
  mobile: string;
  smsPermission: string;
  contactMethod: string;
}

export interface IData {
  returnAuthorization: IReturnAuthorization | null;
}

export function useQuery(id: string) {
  const tuple = mockDataUtil.useGetMockReturnAuthorization(id);

  return React.useMemo(
    () => {
      const returnAuthorization = tuple.data?.returnAuthorization;
      const data: IData = {
        returnAuthorization: returnAuthorization ? {
          firstName: returnAuthorization.customer.firstName,
          lastName: returnAuthorization.customer.lastName,
          email: returnAuthorization.customer.email,
          emailPermission: returnAuthorization.customer.hasEmailPermission,
          mobile: returnAuthorization.customer.phoneNumber,
          smsPermission: returnAuthorization.customer.smsPermission,
          contactMethod: returnAuthorization.customer.contactMethod
        } : null
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
